if (!customElements.get('cart-drawer-recommendations')) {
  customElements.define(
    'cart-drawer-recommendations',
    class CartDrawerRecommendations extends HTMLElement {
      connectedCallback() {
        this.loadRecommendations(0);
      }

      loadRecommendations(attempt) {
        const productId = this.dataset.productId;
        if (!productId) return;

        const limit = parseInt(this.dataset.limit || '6', 10);
        const cartProductIds = (this.dataset.cartProductIds || '')
          .split(',')
          .filter(Boolean);
        const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        fetch(
          `${rootUrl}recommendations/products.js?product_id=${productId}&limit=${limit}&intent=related`
        )
          .then((response) => {
            if (!response.ok) throw new Error('HTTP ' + response.status);
            return response.json();
          })
          .then((data) => {
            let products = (data && data.products) || [];
            const filtered = products.filter(
              (product) => !cartProductIds.includes(String(product.id))
            );
            if (filtered.length >= 2) products = filtered;
            if (!products.length) return;

            const list = this.querySelector('.cart-drawer__recommendations-list');
            if (!list) return;
            list.innerHTML = products.map((product) => this.cardHTML(product)).join('');
            this.removeAttribute('hidden');
          })
          .catch(() => {
            if (attempt < 2 && this.isConnected) {
              setTimeout(() => this.loadRecommendations(attempt + 1), 1500);
            }
          });
      }

      cardHTML(product) {
        let imageSrc = product.featured_image || '';
        if (imageSrc) {
          imageSrc += (imageSrc.includes('?') ? '&' : '?') + 'width=360';
        }
        const image = imageSrc
          ? `<img src="${imageSrc}" alt="" loading="lazy" width="180" height="180">`
          : '';
        return `
          <li class="cart-drawer__recommendation-card">
            <a href="${product.url}" class="cart-drawer__recommendation-link">
              <div class="cart-drawer__recommendation-media">${image}</div>
              <p class="cart-drawer__recommendation-title">${this.escapeHTML(product.title)}</p>
              <p class="cart-drawer__recommendation-price">${this.formatMoney(product.price)}</p>
            </a>
          </li>
        `;
      }

      formatMoney(cents) {
        return (
          (cents / 100).toLocaleString('da-DK', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }) + ' kr'
        );
      }

      escapeHTML(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
      }
    }
  );
}
